export enum MigrationSpecialFields {
  AUTOCOMPLETE = 'autocomplete',
  SELECT = 'select',
  RADIO_GROUP = 'radiogroup',
  CHECKBOX_GROUP = 'checkboxgroup',
}
